import React, { useEffect, useState } from 'react'
import { Link, Element, scroller } from 'react-scroll'
import StickyBox from 'react-sticky-box'

import { useWindowSize } from '../utils/hooks'
import ImgProductPlaceholder from '../../../images/product-placeholder.png'

const ProductImages = ({ productData, selectedVariant }) => {
  const [isFirstLoaded, setIsFirstLoaded] = useState(false)
  const size = useWindowSize()

  useEffect(() => {
    if (
      size.width >= 768 &&
      isFirstLoaded &&
      selectedVariant &&
      selectedVariant.featured_image
    ) {
      scroller.scrollTo(
        `image-position-${selectedVariant.featured_image.position}`,
        {
          duration: 500,
          smooth: true,
          offset: -100, // Scrolls to element + 50 pixels down the page
        }
      )
    }
    if (selectedVariant && selectedVariant.featured_image) {
      setIsFirstLoaded(true)
    }
  }, [selectedVariant])

  return (
    <div className='product-images-wrapper'>
      <div className='product-thumbnails'>
        <StickyBox offsetTop={100} offsetBottom={20}>
          <ul>
            {productData.media ? (
              productData.media.map((image) => (
                <li key={image.id}>
                  <Link
                    activeClass='active'
                    to={`image-position-${image.position}`}
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={500}
                    data-thumbnail-id={image.id}
                    //  data-product-single-thumbnail{% if featured_image == image %} aria-current="true"{% endif %}
                  >
                    <img
                      className='product-single__thumbnail-image'
                      src={image.src}
                      alt={image.alt}
                    />
                  </Link>
                </li>
              ))
            ) : (
              <li>
                <Link
                  activeClass='active'
                  to={`image-position-0`}
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                  //  data-product-single-thumbnail{% if featured_image == image %} aria-current="true"{% endif %}
                >
                  <img
                    className='product-single__thumbnail-image'
                    src={ImgProductPlaceholder}
                    alt='placeholder'
                  />
                </Link>
              </li>
            )}
          </ul>
        </StickyBox>
      </div>
      <div className='product-images element' id='product_images_container'>
        {productData.media ? (
          productData.media.map((image, i) => (
            <Element
              name={`image-position-${image.position}`}
              className='element responsive-image__wrapper'
              key={image.id}
            >
              <div
                id={`ImageWrapper-${image.id}-${i}`}
                data-image-id={image.id}
                data-product-image-wrapper
              >
                <img
                  id={`Image-${image.id}-${i}`}
                  className='responsive-image__image lazyload '
                  src={image.src}
                  data-src={image.src}
                  data-widths={image.width}
                  data-aspectratio={image.aspect_ratio}
                  data-sizes='auto'
                  tabIndex='-1'
                  alt={image.alt}
                />
              </div>
            </Element>
          ))
        ) : (
          <Element
            name={`image-position-0`}
            className='element responsive-image__wrapper'
          >
            <div id={`ImageWrapper-0`} data-product-image-wrapper>
              <img
                id={`Image-0`}
                className='responsive-image__image lazyload '
                src={ImgProductPlaceholder}
                data-src={ImgProductPlaceholder}
                data-sizes='auto'
                tabIndex='-1'
                alt='placeholder'
              />
            </div>
          </Element>
        )}
      </div>
    </div>
  )
}

export default ProductImages
